export default __webpack_public_path__ + "static/media/img61.851747f7.jpg";